<template>
  <div
    v-if="show"
    class="fixed inset-0 bg-gray-900 bg-opacity-60 overflow-y-hidden h-full w-full flex items-center justify-center text-base"
  >
    <div
      class="bg-white rounded-lg shadow-xl w-9/12 h-[90vh] flex flex-col justify-center"
    >
      <!-- Modal Header -->
      <div class="flex items-center justify-between p-4 border-b">
        <h2 class="text-2xl text-gray-800 font-semibold">Stock Details</h2>
        <button
          @click="closeModal"
          class="text-gray-500 hover:text-gray-700"
          aria-label="Close"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Modal Content -->
      <div
        class="flex-grow p-6 space-y-8 text-sm text-gray-700 overflow-y-auto"
      >
        <!-- Section 1: General Info -->
        <div>
          <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
            General Information
          </h3>
          <div class="grid grid-cols-2 gap-y-4 gap-x-8 mt-4">
            <div>
              <strong>Category:</strong> {{ medicationDetails.category }}
            </div>
            <div>
              <strong>Location:</strong> {{ medicationDetails.location }}
            </div>
            <div>
              <strong>National Drug Code (NDC):</strong>
              {{ medicationDetails.ndc }}
            </div>
            <div>
              <strong>Requires Prescription:</strong>
              {{ medicationDetails.requiresPrescription }}
            </div>
          </div>
        </div>

        <!-- Section 2: Medicine Details -->
        <div>
          <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
            Medicine Details
          </h3>
          <div class="grid grid-cols-2 gap-y-4 gap-x-8 mt-4">
            <div>
              <strong>Medicine Type:</strong>
              {{ medicationDetails.medicineType }}
            </div>
            <div>
              <strong>Unit of Measure:</strong>
              {{ medicationDetails.unitOfMeasure }}
            </div>
            <div>
              <strong>Generic Name:</strong> {{ medicationDetails.genericName }}
            </div>
            <div>
              <strong>Brand Name:</strong> {{ medicationDetails.brandName }}
            </div>
            <div>
              <strong>Formulation Type:</strong>
              {{ medicationDetails.formulationType }}
            </div>
            <div>
              <strong>Dosage Strength:</strong>
              {{ medicationDetails.dosageStrength }}
            </div>
          </div>
        </div>

        <!-- Section 3: Stock and Batch Details -->
        <div>
          <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
            Stock and Batch Details
          </h3>
          <div class="grid grid-cols-2 gap-y-4 gap-x-8 mt-4">
            <div>
              <strong>Total Quantity:</strong>
              {{ medicationDetails.totalQuantity }}
            </div>
            <div>
              <strong>Batch Number:</strong> {{ medicationDetails.batchNo }}
            </div>
            <div>
              <strong>Cost Per Unit:</strong>
              {{ medicationDetails.costPerUnit }} Ksh
            </div>
            <div>
              <strong>Reorder Level:</strong>
              {{ medicationDetails.reorderLevel }}
            </div>
            <div>
              <strong>Minimum Reorder Volume:</strong>
              {{ medicationDetails.minimumReorderVolume }}
            </div>
            <div>
              <strong>Status: </strong>
              <span :class="getStatusStyle(medicationDetails.status)">
                {{ medicationDetails.status }}
              </span>
            </div>
          </div>
        </div>

        <!-- Section 4: Storage and Expiry -->
        <div>
          <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
            Storage & Expiry
          </h3>
          <div class="grid grid-cols-2 gap-y-4 gap-x-8 mt-4">
            <div>
              <strong>Storage Conditions:</strong>
              {{ medicationDetails.storageConditions }}
            </div>
            <div>
              <strong>Expiry Date:</strong> {{ medicationDetails.expiryDate }}
            </div>
          </div>
        </div>

        <!-- Section 5: Additional Notes -->
        <div v-if="medicationDetails.notes">
          <h3 class="text-lg font-semibold text-gray-800 border-b pb-2">
            Notes
          </h3>
          <p class="mt-4">{{ medicationDetails.notes }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InventoryQueueModal",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    medicationDetails: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      drugForm: {
        trade_name: "",
        generic_name: "",
        item_type: 1,
        drug_category_id: "",
        strength: "",
        drug_strength_unit_id: "",
        storage_conditions: "",
        drug_dosage_form_id: "",
        is_prescription_required: "",
        is_batch_required: "",
        prescription_required: "",
        manufacturer: "",
      },
      nonDrugForm: {
        trade_name: "",
        item_type: 2,
        storage_conditions: "",
        is_batch_required: "",
        manufacturer: "",
      },
    };
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    getStatusStyle(status) {
      switch (status) {
        case "In Stock":
          return "bg-blue-50 text-custom-blue";
        case "Low Stock":
          return "bg-orange-50 text-custom-yellow";
        case "Out Of Stock":
          return "bg-red-50 text-red-500";
        default:
          return "bg-gray-50 text-gray-800";
      }
    },
  },
};
</script>

<style scoped>
/* Optional: Add custom styling to improve spacing */
</style>
